import { useState } from 'react';
import CustomSelect from '../../../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';
import { TableInput } from '../../../../../../components/common';
interface IProps {
  apiData: any;
}
const TBody = ({ apiData }: IProps) => {
  return (
    <tbody>
      { apiData &&
          Object.keys(apiData).map((machineNumber: any, index: number) => {
            const partCountDefectWise = apiData[machineNumber];
            return (
              <tr>
                <td>{index + 1}</td>
                <td>{machineNumber}</td>
                {partCountDefectWise.map((count: number) => {
                  return <td>{count}</td>;
                })}
                <td>
                  {partCountDefectWise.reduce(
                    (sum: number, num: number) => sum + num
                  )}
                </td>
              </tr>
            );
          })}
    </tbody>
  );
};

export default TBody;
